import Axios from "axios";
import { url } from "../../global";

const saveKanbanADMProd = (data) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SAVE_KANBANADMPROD',
            payload: Axios.post(`${url}/kanban-adm-production`, {
                rack_id: data.rack_id,
                rack_name: data.rack_name,
                parts: data.parts
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
        })
    }
}

export { saveKanbanADMProd }